import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  Field,
  FieldAndResourcePart,
  VisibleFieldsForResource,
} from '®app/resource/edit/visible-fields';
import { BibliographicResource } from '®shared/bibliographic-resource';

@Component({
  selector: 'rl-resource-edit-add-fields',
  templateUrl: './resource-edit-add-fields.component.html',
})
export class ResourceEditAddFieldsComponent {
  @Input() hasPartOfResource: boolean;
  @Input() visibleFields: VisibleFieldsForResource;
  @Output() addedField = new EventEmitter<FieldAndResourcePart>();

  fields: Partial<Record<keyof BibliographicResource, Field>> = {
    authors: {
      name: 'authors',
      label: $localize`:@@resourceEditAddFields-authors:Authors`,
      isIterable: true,
    },
    editors: {
      name: 'editors',
      label: $localize`:@@resourceEditAddFields-editors:Editors`,
      isIterable: true,
    },
    edition: {
      name: 'edition',
      label: $localize`:@@resourceEditAddFields-edition:Edition`,
      isIterable: false,
    },
    volume: {
      name: 'volume',
      label: $localize`:@@resourceEditAddFields-volume:Volume`,
      isIterable: false,
    },
    issue: {
      name: 'issue',
      label: $localize`:@@resourceEditAddFields-issue:Issue`,
      isIterable: false,
    },
    dates: {
      name: 'dates',
      label: $localize`:@@resourceEditAddFields-dates:Dates`,
      isIterable: true,
    },
    web_addresses: {
      name: 'web_addresses',
      label: $localize`:@@resourceEditAddFields-web_addresses:Web addresses`,
      isIterable: true,
    },
    doi: {
      name: 'doi',
      label: $localize`:@@resourceEditAddFields-doi:DOI`,
      isIterable: false,
    },
    optionalIsbn10s: {
      name: 'optionalIsbn10s',
      label: $localize`:@@resourceEditAddFields-optionalIsbn10s:ISBN-10s`,
      isIterable: true,
    },
    optionalIsbn13s: {
      name: 'optionalIsbn13s',
      label: $localize`:@@resourceEditAddFields-optionalIsbn13s:ISBN-13s`,
      isIterable: true,
    },
    issns: {
      name: 'issns',
      label: $localize`:@@resourceEditAddFields-issns:ISSNs`,
      isIterable: true,
    },
    eissns: {
      name: 'eissns',
      label: $localize`:@@resourceEditAddFields-eissns:EISSNs`,
      isIterable: true,
    },
    lcn: {
      name: 'lcn',
      label: $localize`:@@resourceEditAddFields-lcn:LCN`,
      isIterable: false,
    },
    publisher_names: {
      name: 'publisher_names',
      label: $localize`:@@resourceEditAddFields-publisher_names:Publisher names`,
      isIterable: true,
    },
    places_of_publication: {
      name: 'places_of_publication',
      label: $localize`:@@resourceEditAddFields-places_of_publication:Places of publication`,
      isIterable: true,
    },
    page_start: {
      name: 'page_start',
      label: $localize`:@@resourceEditAddFields-page_start:Start page`,
      isIterable: false,
    },
    page_end: {
      name: 'page_end',
      label: $localize`:@@resourceEditAddFields-page_end:End page`,
      isIterable: false,
    },
    number: {
      name: 'number',
      label: $localize`:@@resourceEditAddFields-number:Number`,
      isIterable: false,
    },
    identifier: {
      name: 'identifier',
      label: $localize`:@@resourceEditAddFields-identifier:Identifier`,
      isIterable: false,
    },
    format: {
      name: 'format',
      label: $localize`:@@resourceEditAddFields-format:Format`,
      isIterable: false,
    },
    court: {
      name: 'court',
      label: $localize`:@@resourceEditAddFields-court:Court`,
      isIterable: false,
    },
    location: {
      name: 'location',
      label: $localize`:@@resourceEditAddFields-location:Location`,
      isIterable: false,
    },
    series: {
      name: 'series',
      label: $localize`:@@resourceEditAddFields-series:Series`,
      isIterable: false,
    },
  };

  addFieldToForm(fieldAndResourcePart: FieldAndResourcePart): void {
    this.addedField.emit(fieldAndResourcePart);
  }
}
